/*
Jira: https://mch-applicationservices.atlassian.net/browse/AB-1254
Figma: https://www.figma.com/file/TENnOP4K38G6r3vDL3emCP?node-id=22726:455028
Storybook: https://storybook-uikit-dev.azurewebsites.net/?path=/story/components-structure-editorial-hero--editorial-hero
*/

import React from 'react'
import { EditorialHero } from '@mch-group/uikit-components'
import { Media, MediaContextProvider } from '@responsive'
import useEMHS from './useEMHS'

/**
 *
 * This function returns the component of the Editorial Module Hero
 * @param props.id The id of the component
 * @param props.emehs_collection_action_button The collection button
 * @returns {JSX.Element} - The component of the Editorial Module Hero
 */
const EditorialModuleHero = (props) => {
  const {
    id,
    emhs_image_upload,
    videoCoverImg,
    getImageUrl,
    dataProps,
    noCookiesModalProp
  } = useEMHS(props)
  return (
    <section id={id} className='mt-0 em-hero'>
      <MediaContextProvider>
        <Media at='xs'>
          <EditorialHero
            urlImage={getImageUrl(emhs_image_upload, 397, '4:5')}
            urlVideoCoverImage={videoCoverImg(397, '4:5')}
            {...noCookiesModalProp}
            {...dataProps}
          />
        </Media>
        <Media at='sm'>
          <EditorialHero
            urlImage={getImageUrl(emhs_image_upload, 720, '4:5')}
            urlVideoCoverImage={videoCoverImg(720, '4:5')}
            {...noCookiesModalProp}
            {...dataProps}
          />
        </Media>
        <Media between={['md', 'xl']}>
          <EditorialHero
            urlImage={getImageUrl(emhs_image_upload, 1000, '21:9')}
            urlVideoCoverImage={videoCoverImg(1000, '21:9')}
            {...noCookiesModalProp}
            {...dataProps}
          />
        </Media>
        <Media between={['xl', 'xxl']}>
          <EditorialHero
            urlImage={getImageUrl(emhs_image_upload, 1213, '21:9')}
            urlVideoCoverImage={videoCoverImg(1213, '21:9')}
            {...noCookiesModalProp}
            {...dataProps}
          />
        </Media>
        <Media greaterThanOrEqual='xxl'>
          <EditorialHero
            urlImage={getImageUrl(emhs_image_upload, 1472, '21:9')}
            urlVideoCoverImage={videoCoverImg(1472, '21:9')}
            {...noCookiesModalProp}
            {...dataProps}
          />
        </Media>
      </MediaContextProvider>
    </section>
  )
}

export default EditorialModuleHero
